var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEr4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.52 18.99C22.7692 19.3412 22.9257 19.7497 22.9751 20.1774C23.0246 20.6052 22.9653 21.0386 22.8028 21.4374C22.6403 21.8362 22.3798 22.1875 22.0454 22.4589C21.7111 22.7303 21.3137 22.913 20.89 22.99C20.7468 22.9999 20.6031 22.9999 20.46 22.99C20.3135 23 20.1665 23 20.02 22.99C19.5977 22.9106 19.2021 22.7266 18.8693 22.4548C18.5365 22.183 18.2772 21.8321 18.1151 21.4342C17.9529 21.0363 17.8931 20.604 17.9412 20.1771C17.9892 19.7501 18.1435 19.342 18.39 18.99L19.86 16.79C19.9256 16.691 20.0148 16.6098 20.1195 16.5536C20.2242 16.4974 20.3412 16.468 20.46 16.468C20.5788 16.468 20.6958 16.4974 20.8004 16.5536C20.9051 16.6098 20.9943 16.691 21.06 16.79L22.52 18.99Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C11 21 20 12 11 21M20 12C20 7.02944 15.9706 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21M20 12C20 12 15.8409 10.1591 12.5 13.5C9.15913 16.8409 11 21 11 21",
    stroke: "#35383D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C17 8.68629 14.3137 6 11 6C7.68629 6 5 8.68629 5 12C5 15.3137 7.68629 18 11 18",
    stroke: "#35383D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr4);
export default __webpack_public_path__ + "static/media/er-4.d628f07e3b945dd9021d7d426922ac3d.svg";
export { ForwardRef as ReactComponent };